<template>
    <span>
        <router-link
            v-if="useRouter && encodedId"
            :to="{
                name: 'item',
                params: { id: encodedId }
            }"
            :target="newTab ? '_blank' : '_self'"
        >
            <span v-html="itemName"></span> {{ status }}
        </router-link>
        <a
            v-else-if="!useRouter && item.ci_url"
            :href="item.ci_url || '#'"
            v-html="itemName"
            :target="newTab ? '_blank' : '_self'"
        >
        </a>
        <a
            v-else-if="!useRouter && encodedId"
            :href="CI_PATH + encodedId"
            v-html="itemName"
            :target="newTab ? '_blank' : '_self'"
        >
        </a>
        <span v-else v-html="itemName"> </span>
        <input type="hidden" name="item-id" :value="item.id ? item.id : ''" />
    </span>
</template>

<script>
export default {
    name: "itemName",
    props: {
        item: {
            type: Object,
            required: true
        },
        text: {
            type: String,
            default: null
        },
        useRouter: {
            type: Boolean,
            default: true
        },
        newTab: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            CI_PATH: `${process.env.APPS}inventory/item/view/`
        };
    },
    computed: {
        itemName() {
            return this.text || this.item.name;
        },
        encodedId() {
            return this.item.encoded_id || this.item.encodedId;
        },
        status() {
            if ("status" in this.item) {
                return this.item.status ? "" : "(inactive)";
            }
            return "";
        }
    }
};
</script>
